<dx-popup
    #selectVendorProposalPopup
    minWidth="150px"
    minHeight="150px"
    width="50%"
    height="65%"
    title="Select Vendor"
    [showTitle]="true"
    [showCloseButton]="true"
    [shading]="false"
    [dragEnabled]="true"
    [resizeEnabled]="true"
    [closeOnOutsideClick]="false"
    [(visible)]="visible"
    (onShown)="onPopupShown()"
    (onHidden)="onPopupClose()"
>
    <div *dxTemplate="let data of 'content'">
        <dx-box width="100%" height="100%" direction="col">
            <dxi-item baseSize="auto">
                <div *dxTemplate class="add-padding-bottom">
                    <dx-radio-group
                        valueExpr="key"
                        displayExpr="displayText"
                        layout="horizontal"
                        [items]="vendorTypes"
                        [(value)]="selectedVendorType"
                        (onValueChanged)="onVendorTypeChange($event)"
                    ></dx-radio-group>
                </div>
            </dxi-item>
            <dxi-item [ratio]="1" *ngIf="selectedVendorType === 'community' || selectedVendorType === 'all'">
                <div *dxTemplate>
                    <dx-data-grid
                        #vendorDataGrid
                        width="100%"
                        height="100%"
                        keyExpr="vendorId"
                        [dataSource]="vendorList"
                        [showBorders]="true"
                        [showRowLines]="true"
                        [rowAlternationEnabled]="true"
                        [wordWrapEnabled]="true"
                        [hoverStateEnabled]="true"
                        [columnHidingEnabled]="true"
                        [columnMinWidth]="30"
                        [columnAutoWidth]="true"
                        [allowColumnReordering]="true"
                        [allowColumnResizing]="true"
                        columnResizingMode="nextColumn"
                    >
                        <dxo-header-filter [visible]="true"></dxo-header-filter>
                        <dxo-filter-panel [visible]="true"></dxo-filter-panel>
                        <dxo-filter-row [visible]="true"></dxo-filter-row>
                        <ng-container *ngIf="selection === 'multiple'">
                            <dxo-selection
                                selectAllMode="allPages"
                                showCheckBoxesMode="always"
                                mode="multiple"
                            ></dxo-selection>
                        </ng-container>
                        <ng-container *ngIf="selection === 'single'">
                            <dxi-column
                                alignment="center"
                                cellTemplate="actionTemplate"
                                caption=""
                                [width]="90"
                            ></dxi-column>
                        </ng-container>
                        <dxi-column dataType="string" dataField="vendorName" caption="Name"></dxi-column>
                        <dxi-column dataType="string" dataField="vendorType" caption="Type"></dxi-column>
                        <dxi-column dataType="string" dataField="address" caption="Address"></dxi-column>
                        <dxi-column
                            dataType="boolean"
                            dataField="isActive"
                            caption="Active"
                            cellTemplate="booleanValueCellTemplate"
                        ></dxi-column>

                        <div *dxTemplate="let cell of 'actionTemplate'">
                            <dx-button
                                type="default"
                                text="Save"
                                [icon]="iconSave"
                                (onClick)="onSingleSelection(cell.data)"
                            ></dx-button>
                        </div>

                        <div *dxTemplate="let data of 'booleanValueCellTemplate'">
                            <div *ngIf="data.value === true; then checkBlock; else crossBlock"></div>
                            <ng-template #checkBlock>
                                <i class="cc-1-5x cc-icon-check" [ngClass]="iconCheck"></i>
                            </ng-template>
                            <ng-template *ngIf="data.value === false" #crossBlock>
                                <i class="cc-1-5x cc-icon-cross" [ngClass]="iconCross"></i>
                            </ng-template>
                        </div>
                    </dx-data-grid>
                </div>
            </dxi-item>
            <dxi-item [ratio]="1" *ngIf="selectedVendorType === 'temporary'">
                <div *dxTemplate>
                    <dx-box width="100%" height="100%" direction="col">
                        <dxi-item baseSize="auto">
                            <div *dxTemplate>
                                <dx-toolbar width="100%" class="add-padding-bottom">
                                    <dxi-item location="after">
                                        <dx-button
                                            type="default"
                                            text="Add New Temporary Vendor"
                                            [icon]="iconPlus"
                                            (onClick)="onAddNewTemporaryVendorClick()"
                                        ></dx-button>
                                    </dxi-item>
                                </dx-toolbar>
                            </div>
                        </dxi-item>
                        <dxi-item [ratio]="1">
                            <div *dxTemplate>
                                <dx-data-grid
                                    #temporaryVendorDataGrid
                                    width="100%"
                                    height="100%"
                                    keyExpr="vendorId"
                                    [dataSource]="temporaryVendorList"
                                    [showBorders]="true"
                                    [showRowLines]="true"
                                    [rowAlternationEnabled]="true"
                                    [wordWrapEnabled]="true"
                                    [hoverStateEnabled]="true"
                                    [columnHidingEnabled]="true"
                                    [columnMinWidth]="30"
                                    [columnAutoWidth]="true"
                                    [allowColumnReordering]="true"
                                    [allowColumnResizing]="true"
                                    columnResizingMode="nextColumn"
                                >
                                    <dxo-header-filter [visible]="true"></dxo-header-filter>
                                    <dxo-filter-panel [visible]="true"></dxo-filter-panel>
                                    <dxo-filter-row [visible]="true"></dxo-filter-row>
                                    <ng-container *ngIf="selection === 'multiple'">
                                        <dxo-selection
                                            selectAllMode="allPages"
                                            showCheckBoxesMode="always"
                                            mode="multiple"
                                        ></dxo-selection>
                                    </ng-container>
                                    <ng-container *ngIf="selection === 'single'">
                                        <dxi-column
                                            alignment="center"
                                            cellTemplate="actionTemplate"
                                            caption=""
                                            [width]="90"
                                        ></dxi-column>
                                    </ng-container>

                                    <dxi-column dataType="string" dataField="vendorName" caption="Name"></dxi-column>
                                    <dxi-column dataType="string" dataField="address" caption="Address"></dxi-column>

                                    <div *dxTemplate="let cell of 'actionTemplate'">
                                        <dx-button
                                            type="success"
                                            text="Save"
                                            hint="Save"
                                            [icon]="iconSave"
                                            (onClick)="onSingleSelection(cell.data)"
                                        ></dx-button>
                                    </div>
                                </dx-data-grid>
                            </div>
                        </dxi-item>
                    </dx-box>
                </div>
            </dxi-item>
            <dxi-item baseSize="auto">
                <div *dxTemplate>
                    <dx-toolbar width="100%">
                        <dxi-item location="before">
                            <div *dxTemplate>
                                <dx-button
                                    type="default"
                                    text="Cancel"
                                    hint="Cancel"
                                    [icon]="iconCancel"
                                    (onClick)="onPopupClose()"
                                ></dx-button>
                            </div>
                        </dxi-item>
                        <dxi-item *ngIf="selection === 'multiple'" location="after">
                            <div *dxTemplate>
                                <dx-button
                                    type="success"
                                    text="Save"
                                    hint="Save"
                                    [icon]="iconCheck"
                                    (onClick)="onMultipleSelectionClick()"
                                ></dx-button>
                            </div>
                        </dxi-item>
                    </dx-toolbar>
                </div>
            </dxi-item>
        </dx-box>
    </div>
</dx-popup>

<app-add-temporary-vendor
    *ngIf="showAddNewTemporaryVendor"
    [communityId]="communityId"
    [workOrderId]="workOrderId"
    (onClose)="onAddNewTemporaryVendorClose($event)"
></app-add-temporary-vendor>

<cc-message-box #venodorForProposalMessageBox></cc-message-box>
